import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import {
  cleanUpSubscriptions,
  registerCloseOtherSubMenus,
} from '../../filtro-utils';
import { Subscription } from 'rxjs';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { NgIcon } from '@ng-icons/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { FiltroComponent } from '../../filtro.component';

type FiltroRamo = { ramo: string; subRamos: string[] }[];

@Component({
  selector: 'sub-filtro-ramos',
  templateUrl: './ramos.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    NgIcon,
  ],
})
export class RamosComponent implements OnInit {
  @Input('filtroRamo') filtroRamo: FiltroRamo;
  @Input('currentTab') currentTab = IntegracaoConstants.ramosTabs[0];
  @Output() filtroRamoChange = new EventEmitter<FiltroRamo>();

  @ViewChildren(MatMenuTrigger) allTriggers!: QueryList<MatMenuTrigger>;

  private subscriptions: Subscription[] = [];

  protected readonly ramos = [
    { nome: 'Auto', icon: 'car-current-color' },
    { nome: 'Compreensivos', icon: 'shield-outline-current-color' },
    { nome: 'Vida', icon: 'cards-heart-current-color' },
    { nome: 'Diversos', icon: 'hexagon-multiple-current-color' },
  ];

  protected readonly subRamos = {
    Auto: [
      { nome: 'Carro', icon: 'car-side-current-color' },
      { nome: 'Motocicleta', icon: 'motorbike-current-color' },
      { nome: 'Caminhão', icon: 'truck-current-color' },
    ],
    Compreensivos: [
      { nome: 'Residencial', icon: 'residencial' },
      { nome: 'Condomínio', icon: 'condominio' },
      { nome: 'Empresarial', icon: 'empresarial' },
    ],
    Vida: [
      { nome: 'Vida Individual', icon: 'vida-individual' },
      { nome: 'Vida Global', icon: 'vida-global-current-color' },
      { nome: 'Acidentes Pessoais', icon: 'acidentes-pessoais' },
      { nome: 'Viagem', icon: 'viagem' },
    ],
    Diversos: [
      { nome: 'Aluguel', icon: 'aluguel' },
      { nome: 'Bike', icon: 'bike-current-color' },
      { nome: 'Celular', icon: 'smartphone' },
    ],
  };

  constructor(
    private filtroService: FiltroControllerService,
    @Optional() private filtroComp?: FiltroComponent
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    registerCloseOtherSubMenus(this.allTriggers, this.subscriptions);

    this.allTriggers.changes.subscribe(() => {
      cleanUpSubscriptions(this.subscriptions);
      registerCloseOtherSubMenus(this.allTriggers, this.subscriptions);
    });
  }

  ngOnDestroy() {
    cleanUpSubscriptions(this.subscriptions);
  }

  updateFiltroRamo(ramo: string, subRamo: string) {
    let currentRamo = this.filtroRamo.find((x) => x.ramo == ramo);

    if (!currentRamo) {
      currentRamo = { ramo: ramo, subRamos: [] };
      this.filtroRamo.push(currentRamo);
    }

    const ramoIndex = this.filtroRamo.findIndex((x) => x.ramo == ramo);

    const subRamoIndex = currentRamo.subRamos.findIndex(
      (x) => x == this.normalize(subRamo)
    );

    const subRamos = this.filtroRamo[ramoIndex].subRamos;

    subRamoIndex >= 0
      ? subRamos.splice(subRamoIndex, 1)
      : subRamos.push(this.normalize(subRamo));

    if (subRamos.length == 0) this.filtroRamo.splice(ramoIndex, 1);

    this.filtroRamoChange.emit(this.filtroRamo);

    this.updateActiveFilters();
  }

  private updateActiveFilters() {
    let activeFilterCount = 0;

    for (const filtro of this.filtroRamo) {
      activeFilterCount += filtro.subRamos.length;
    }

    this.filtroService.updateActiveFilters('ramos', activeFilterCount);

    this.filtroComp?.sendFilter(false);
  }

  getSubRamosCount(ramoNome: string): number {
    const entry = this.filtroRamo.find((item) => item.ramo === ramoNome);

    return entry?.subRamos?.length ?? 0;
  }

  isRamoChecked(ramo: string, subRamo: string): boolean {
    const ramoIndex = this.filtroRamo.findIndex((x) => x.ramo == ramo);

    return this.filtroRamo[ramoIndex]?.subRamos?.includes(
      this.normalize(subRamo)
    );
  }

  normalize(string: string) {
    return string
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  capitalizeFirst(str: string): string {
    const lower = str.toLowerCase();
    return lower[0].toUpperCase() + lower.slice(1);
  }
}
